import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { certificateToProject } from "../../store/certificates/actions";
export var PostCertificatesToProject = function (trigger, idCertificate, idProject) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingCertificateToProject: state.Certificates.loadingCertificateToProject,
        responseCertificateToProject: state.Certificates.responseCertificateToProject,
        errorCertificateToProject: state.Certificates.errorCertificateToProject,
    }); }), loadingCertificateToProject = _a.loadingCertificateToProject, responseCertificateToProject = _a.responseCertificateToProject, errorCertificateToProject = _a.errorCertificateToProject;
    useEffect(function () {
        if (trigger) {
            dispatch(certificateToProject({
                id: idCertificate,
                idProject: idProject,
            }));
        }
    }, [trigger, idCertificate, idProject]);
    return {
        loadingCertificateToProject: loadingCertificateToProject,
        responseCertificateToProject: responseCertificateToProject,
        errorCertificateToProject: errorCertificateToProject,
    };
};
